var map = {
	"./text-1.png": 9915,
	"./text-2.png": 1584,
	"./text-3.png": 6057,
	"./text-4.png": 5974,
	"./text-5.png": 2911,
	"./text-6.png": 6052,
	"./text-7.png": 9949,
	"./text-8.png": 2170,
	"./text-9.png": 9923,
	"./text-back.png": 8825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2643;